import { render, staticRenderFns } from "./SsoWrapper.vue?vue&type=template&id=37642585&scoped=true&"
import script from "./SsoWrapper.vue?vue&type=script&lang=js&"
export * from "./SsoWrapper.vue?vue&type=script&lang=js&"
import style0 from "./SsoWrapper.vue?vue&type=style&index=0&id=37642585&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37642585",
  null
  
)

export default component.exports